import { call, put, takeEvery } from "redux-saga/effects";
import SweetAlert from "../../../components/sweetalert/SweetAlert";
import * as actions from "./TimeZoneMasterActions";
import * as services from "./TimeZoneMasterServices";
import * as types from "./TimeZoneMasterActionType";

function* fetchMasterTimeZoneSaga() {
  try {
    const response = yield call(services.fetchMasterTimeZoneService);
    yield put(actions.fetchMasterTimeZoneSuccess(response?.values || {}));
  } catch (error) {
    const errorMessage = error?.message || "Failed to fetch master time zones";
    yield put(actions.fetchMasterTimeZoneFailure(errorMessage));
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
  }
}

function* TimeZoneMasterSaga() {
  yield takeEvery(types.MASTER_TIMEZONE_REQUEST, fetchMasterTimeZoneSaga);
}

export default TimeZoneMasterSaga;